const featureData = [
  {
    id: 1,
    title: "Explore the world",
    icon: "feature-box__icon icon-basic-world",
    info: ` Lorem ipsum, dolor sit amet consectetur adipisicing elit. At
  laudantium, natus voluptatum ipsum eaque id esse molestias minima
  quidem ipsam! Quo deserunt atque obcaecati rerum itaque dolor hic
  aliquid consequuntur.`,
  },
  {
    id: 2,
    title: "Meet Nature",
    icon: "feature-box__icon icon-basic-compass",
    info: ` Lorem ipsum, dolor sit amet consectetur adipisicing elit. At
  laudantium, natus voluptatum ipsum eaque id esse molestias minima
  quidem ipsam! Quo deserunt atque obcaecati rerum itaque dolor hic
  aliquid consequuntur.`,
  },
  {
    id: 3,
    title: "Find your way",
    icon: "feature-box__icon icon-basic-map",
    info: ` Lorem ipsum, dolor sit amet consectetur adipisicing elit. At
  laudantium, natus voluptatum ipsum eaque id esse molestias minima
  quidem ipsam! Quo deserunt atque obcaecati rerum itaque dolor hic
  aliquid consequuntur.`,
  },
  {
    id: 4,
    title: "Live a healthier life",
    icon: "feature-box__icon icon-basic-heart",
    info: ` Lorem ipsum, dolor sit amet consectetur adipisicing elit. At
  laudantium, natus voluptatum ipsum eaque id esse molestias minima
  quidem ipsam! Quo deserunt atque obcaecati rerum itaque dolor hic
  aliquid consequuntur.`,
  },
];

export default featureData;
